// extracted by mini-css-extract-plugin
export var label = "CatalogDownload-module--label--t7ACf";
export var link = "CatalogDownload-module--link--qkgIQ";
export var title = "CatalogDownload-module--title--NcxUi";
export var wrapper = "CatalogDownload-module--wrapper--CSYfw";